import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';

class ContactFormSuccess extends Component {
  handleClose = (e) => {
    const { onCloseModal } = this.props;
    e.preventDefault();
    onCloseModal();
  };

  render() {
    const { settings } = this.props;
    const { onCloseModal } = this.props;
    if (!settings.data) {
      return (
        <Modal title="Contact Us" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    return (
      <Modal title="Contact Us" onCloseModal={onCloseModal}>
        <p>Thank You!</p>
        <a onClick={this.handleClose}>Close Window</a>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(ContactFormSuccess);
